<script setup lang="ts">
const { isLoggedIn, account } = useAccount();
const showForgotPassword = ref(false);
</script>

<template>
  <UiDefaultPage :title="isLoggedIn ? 'Déconnexion' : 'Connexion'">
    <div class="flex flex-col items-start gap-6 lg:flex-row">
      <div class="relative flex flex-col gap-6 rounded-lg border bg-light p-6 shadow-lg lg:basis-1/2">
        <SvgMascot class="absolute right-0 top-0 size-28 -scale-y-100" />
        <template v-if="account">
          <h3 class="h4 pr-28">
            Vous êtes connecté·e à Lillojeux!<br>
          </h3>
          <div class="flex items-center gap-4">
            <span class="i-local-account size-12  shrink-0 text-muted" />
            <div class="">
              <div class="text-2xl font-bold">
                {{ account.display_name }}
              </div>
              <div class="text-muted">
                {{ account.email }}
              </div>
            </div>
          </div>
          <AuthLogoutForm />
        </template>
        <template v-else>
          <div>
            <h3 class="h4 pr-28">
              Vous avez un compte à Lillojeux?<br>
              Connectez-vous!
            </h3>
            <button class="link-orange" @click="showForgotPassword = !showForgotPassword">
              {{ showForgotPassword ? "Mot de passe retrouvé!": 'Mot de passe oublié?' }}
            </button>
          </div>
          <AuthForgotPasswordForm v-if="showForgotPassword" />
          <AuthLoginForm v-else />
        </template>
      </div>
      <div v-if="!isLoggedIn" class="flex flex-col gap-6 rounded-lg border bg-light p-6 shadow-lg lg:basis-1/2">
        <h3 class="h4">
          Vous n'avez pas de compte à Lillojeux?<br>
          Créez-en un!
        </h3>
        <AuthRegisterForm />
      </div>
    </div>
  </UiDefaultPage>
</template>
